import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/entering-the-eu-market")({
  head: () => buildRouteHead("/zh-cn/entering-the-eu-market", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/zh-cn/industries/pharma-biotech/landing-in-europe", replace: true });
  },
});
